import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import IconButton from '@material-ui/core/IconButton';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import SwipeableViews from 'react-swipeable-views';
import Swal from 'sweetalert2';
import gql from 'graphql-tag';
import moment from 'moment';
import Loader from '../../components/CustomLoader';
import client from '../../utils/apolloClient';
import { getUser } from '../../data-services/queries';
import { listEntriesByEvaluator } from './ettcSubmissionApi';
import Waiting from '../../images/wait.png';
import Confirm from '../../images/confirm.png';

class ListETTCEvaluations extends Component {
    state = {
        loading: true,
        value: 0,
        userData: null,
        entries: [],
    };

    async componentDidMount() {
        const { data } = await client.query({ query: gql(getUser) });
        const userData = data && data.user;
        this.setState({ userData });

        if (!userData || userData.role !== 'FCP' || !userData.sfid) {
            this.setState({ loading: false });
            return;
        }

        try {
            const entries = await listEntriesByEvaluator(userData.sfid);
            this.setState({ entries, loading: false });
        } catch (err) {
            this.setState({ loading: false });
            Swal.fire({
                icon: 'error',
                title: 'Load failed',
                text: (err && err.message) || 'Could not load assigned ETTC evaluations.',
            });
        }
    }

    handleChange = (event, value) => {
        this.setState({ value });
    };

    handleChangeIndex = (index) => {
        this.setState({ value: index });
    };

    gotoBack = () => {
        this.props.history.push('/newHomeFCP');
    };

    openEntry = (entry) => {
        const first = entry.submissions && entry.submissions[0];
        if (!first) return;
        this.props.history.push({
            pathname: '/ettc-submission',
            search: `?id=${first.id}&batch=${encodeURIComponent(
                entry.batchKey
            )}&back=/ettc-evaluations`,
        });
    };

    formatDate = (value) => {
        if (!value) return '-';
        return moment(value).isValid() ? moment(value).format('DD-MMM-YYYY') : value;
    };

    renderList = (items) => {
        if (!items.length) {
            return <Typography style={{ padding: 16 }}>No entries in this list.</Typography>;
        }
        return items.map((entry) => {
            const isPending = entry.pending > 0;
            const statusLabel = isPending ? 'Pending' : 'Approved';
            return (
                <div key={entry.batchKey}>
                    <List
                        onClick={() => this.openEntry(entry)}
                        style={{ cursor: 'pointer', padding: 12 }}
                    >
                        <Grid container spacing={8} alignItems="center">
                            <Grid item xs={7}>
                                <Typography variant="body2">
                                    {entry.fcp_name || 'FCP'}
                                </Typography>
                                <Typography variant="caption">
                                    {entry.submissionName || 'ETTC'} · {entry.total} submission
                                    {entry.total === 1 ? '' : 's'} ·{' '}
                                    {this.formatDate(entry.submission_date__c)}
                                </Typography>
                            </Grid>
                            <Grid item xs={5}>
                                <Typography
                                    align="right"
                                    variant="body1"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    {statusLabel}
                                    <img
                                        src={isPending ? Waiting : Confirm}
                                        alt={statusLabel}
                                        style={{ width: 30, paddingLeft: 10 }}
                                    />
                                </Typography>
                            </Grid>
                        </Grid>
                    </List>
                    <Divider />
                </div>
            );
        });
    };

    render() {
        const { loading, entries, value } = this.state;
        const pending = entries.filter((entry) => entry.pending > 0);
        const approved = entries.filter((entry) => entry.pending === 0 && entry.approved > 0);

        return (
            <div>
                <AppBar position="static">
                    <Toolbar>
                        <IconButton color="inherit" onClick={this.gotoBack}>
                            <ArrowBackIcon />
                        </IconButton>
                        <Typography variant="title" color="inherit">
                            My ETTC Evaluations
                        </Typography>
                    </Toolbar>
                </AppBar>

                {loading ? (
                    <Grid container alignItems="center" justify="center" style={{ marginTop: 24 }}>
                        <Loader type="Audio" color="#00BFFF" height="50" width="50" />
                    </Grid>
                ) : (
                    <Paper square>
                        <Tabs
                            value={value}
                            onChange={this.handleChange}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="fullWidth"
                        >
                            <Tab label={`Pending (${pending.length})`} />
                            <Tab label={`Approved (${approved.length})`} />
                        </Tabs>
                        <SwipeableViews index={value} onChangeIndex={this.handleChangeIndex}>
                            <div>{this.renderList(pending)}</div>
                            <div>{this.renderList(approved)}</div>
                        </SwipeableViews>
                    </Paper>
                )}
            </div>
        );
    }
}

export default ListETTCEvaluations;
